import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { categoryService } from 'shared/services';
import { loadingActions } from 'store';
import { useAppDispatch } from 'store/store';
import toast from 'shared/utils/toast';
import CategoryForm from '../components/CategoryForm';
import { ICategoryState } from '../types';

const initCategory: ICategoryState = {
  id: null,
  code: '',
  description: '',
  sector: null
};

export const CreateCategory = () => {
  const translationPrefix = 'types.categories.new';

  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const createCategory = async (values) => {
    dispatch(loadingActions.startLoading());
    const payload = {
      ...values,
      sector:
        values.sector === '' || values.sector === undefined || values.sector === null
          ? null
          : values.sector
    };
    try {
      await categoryService.add(payload).then(() => toast.crud.successCreate('Categoria', 'f'));
    } catch (error) {
      toast.crud.errorCreate('Categoria');
    } finally {
      dispatch(loadingActions.stopLoading());
    }
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <CategoryForm category={initCategory} onSubmit={createCategory} />
    </TenantPage>
  );
};
